module.exports = __webpack_public_path__ + "img/wossone.9a602269.png";